import { Link } from 'react-router-dom';
import { Target, Ban, Scale, Lock, Info } from 'lucide-react';
import { useAppStore } from '../store/useAppStore';
import { Accordion } from '../components/ui/Accordion';

/** Methodik-, Datenschutz- und Grenzen-Seite (Abschnitt 41, PRIV-005). */
export function AboutPage() {
  const dataModel = useAppStore((state) => state.dataModel);
  const showWeightingTransparency = useAppStore(
    (state) => state.settings.featureFlags.weightingTransparency.aboutPage,
  );

  return (
    <div className="page-container stack">
      <h1>Über den Test</h1>

      <div className="two-col-grid">
        <section className="card stack">
          <Target className="card-icon" aria-hidden="true" />
          <h2>Was der Test bewertet</h2>
          <p>
            Der Test bewertet, ob Instagram unter deinen konkreten Markt-, Angebots-, Arbeits- und
            Persönlichkeitsbedingungen ein sinnvoller Kanal ist. Dafür beantwortest du 14 bewertete
            Fragen und neun kurze Kontextfragen. Aus den Antworten entstehen ein Gesamt-Score und
            sechs Teil-Ergebnisse: Zielgruppe und Nachfrage, Thema und Inhalte, Vertrauen und
            Sichtbarkeit, Umsetzung im Alltag, Angebot und Verkauf sowie Unabhängigkeit von
            Instagram.
          </p>
        </section>

        <section className="card stack">
          <Ban className="card-icon" aria-hidden="true" />
          <h2>Was der Test nicht bewertet</h2>
          <p>
            Der Test bewertet nicht deine Person und liefert keine psychologische Diagnose. Ein
            niedriger Wert ist keine Aussage darüber, dass dein Produkt oder du selbst ungeeignet
            seid – er kann bedeuten, dass ein anderer Kanal aktuell besser passt oder dass zuerst
            Grundlagen aufgebaut werden sollten.
          </p>
        </section>

        <section className="card stack">
          <Scale className="card-icon" aria-hidden="true" />
          <h2>Spannungsfelder</h2>
          <p>
            Ein Spannungsfeld ist kein Punktabzug. Es beschreibt eine Kombination von Antworten, die
            gemeinsam praktische Reibung erzeugt – zum Beispiel wenn Vertrauen wichtig ist, aber
            persönliche Sichtbarkeit unerwünscht ist. Spannungsfelder verändern den 28-Punkte-Score
            nicht, können aber die empfohlene Rolle von Instagram begrenzen.
          </p>
        </section>

        <section className="card stack">
          <Lock className="card-icon" aria-hidden="true" />
          <h2>Deine Daten</h2>
          <p>{dataModel.appConfig.privacy.suggestedNotice}</p>
          <p>
            Du kannst deine gespeicherten Testdaten jederzeit über „Lokale Daten löschen“ auf der
            Ergebnisseite vollständig entfernen.
          </p>
        </section>

        <section className="card stack">
          <Info className="card-icon" aria-hidden="true" />
          <h2>Keine Garantie</h2>
          <p>
            Der Score ist kein Erfolgsversprechen. Er zeigt eine strukturelle Einschätzung auf
            Grundlage deiner Antworten zum jetzigen Zeitpunkt.
          </p>
        </section>
      </div>

      {showWeightingTransparency && (
        <Accordion title="Technische Transparenz: Gewichtungsmatrix">
          <p>
            Jede der 14 Fragen fließt gewichtet in bis zu sechs Cluster ein. Die Gewichte je Frage
            ergeben in Summe immer 1,0. Die vollständige Matrix befindet sich im Datenmodell der App
            (Version {dataModel.manifest.schemaVersion}, Scoring-Version{' '}
            {dataModel.manifest.scoringVersion}, Inhalt-Version {dataModel.manifest.contentVersion}
            ).
          </p>
        </Accordion>
      )}

      <section className="stack" style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
        <Link to="/" className="button button--secondary">
          Zur Startseite
        </Link>
      </section>
    </div>
  );
}
